<template>
  <div class="down-box" v-if="lectoParams.LectotypeParams.length > 0 || lectoParams.IsSelected">

    <el-button class="yulan-button" type="primary" :loading="true" size="small" v-if="stepBuilding && hasProview">正在生成模型</el-button>
    <template v-else-if="!docDetail && hasProview">
      <el-button class="yulan-button" type="primary" @click="stepOnlyProview()" :disabled="!isStepDown" size="small">预览</el-button>
      <el-button class="yulan-button" type="primary" @click="stepProview()" :disabled="!isStepDown" size="small">在线编辑</el-button>
    </template>
      <!-- <el-button class="yulan-button" type="primary" @click="stepProview()" :disabled="!isStepDown" size="small" v-else-if="!docDetail && hasProview">在线编辑</el-button> -->

    <el-button class="yulan-button" type="primary" v-if="docDetail && hasProview" @click="docOnlyProview()" size="small">预览</el-button>
    <el-button class="yulan-button" type="primary" @click="docProview()" size="small" v-if="docDetail && hasProview">在线编辑</el-button>

    <!-- SolidWorks特征模型 -->
    <div v-if="docDetail"></div>
    <div
      class="solid-work-btn"
      :class="isModelDown ? '' : 'disable'"
      @click="modelFileExtDownCheck"
      v-else-if="model_down_progress === 0"
    >下载特征模型</div>
    <div class="solid-work-view open" v-else-if="model_down_progress === 100" @click="openDownFile('model_file')"><div class="solid-work-btn" :style="{ width: '100%' }"></div><span>打开文件夹</span></div>
    <div class="solid-work-view" v-else>
      <div class="solid-work-btn" :style="{ width: `${model_down_progress}%` }"></div>
      <span>{{model_down_progress}}%</span>
    </div>

    <!-- 普通模型 -->
    <div v-if="docDetail"></div>
    <div
      class="down-btn"
      :class="isStepDown ? '' : 'disable'"
      @click="stepDownStart()"
      v-else-if="step_down_progress === 0"
    >下载通用模型</div>
    <div class="down-view open" v-else-if="step_down_progress === 100" @click="openDownFile('step_file')"><div class="down-btn" :style="{ width: '100%' }"></div><span>打开文件夹</span></div>
    <div class="down-view" v-else>
      <div class="down-btn" :style="{ width: `${step_down_progress}%` }"></div>
      <span v-if="step_down_obj.status === 'servicebuild'">正在生成模型</span>
      <span v-else>{{step_down_progress}}%</span>
    </div>
    

    <!-- 图纸 -->
    <btn-doc-down :doc="docDetail" downText="下载通用模型" v-if="docDetail"></btn-doc-down>

    <div class="set-icon" @click="_activeSetupTab"><i class="el-icon-setting"></i></div>
    <HTTokenDialog @getHTToken="getHTToken" ref="getHTTkenRef" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {CheckLibs,UserService} from '@digital-supply-chain/module'
import { Message as ElMessage, MessageBox, Loading } from 'element-ui';
import { ApiService, AuthService, ProductService, DownloadService, ProdHtService } from '@/service';
import { WinForm, Listener, UtilService } from '@/libs';

import { download, downloadCheckFun, getSavePath, getModelSaveType, formatBzjName } from './lectoParamsDown';

import BtnDocDown from './components/BtnDocDown.vue';
import HTTokenDialog from './components/HTTokenDialog.vue';

let file_path = {
  model_file: '',
  step_file: '',
};
let stepProviewTimeoutObj = null;
let stepOnlyProviewTimeoutObj = null;

export default {
  data() {
    return {
      downOption: {},
      isLoading: false,

      stepBuilding: false,
      downloadTimer: null, // 下载循环定时器
      downloadStatus: true, // 判断下载是否成功
    }
  },
  inject: ['productDocs','downLoadCheck','handleClickPreview','createIframe'],
  props: {
    lectoParams: { default: {} },
    lectoProId: { default: 0 },
    productDetail: { default: {} },
    IsAddToCurrentAssembly: { default: false }
  },
  components: { BtnDocDown,HTTokenDialog },
  computed: {
    ...mapState({
      isShow:state => state.modeldown.isShow,
      progressData:state => state.modeldown.progressData,
    }),
    docDetail() {
      let findOne = null;
      this.productDocs.forEach(docs => {
        if(this.lectoParams.SkuName && docs.FileName.toLowerCase()  == this.lectoParams.SkuName.toLowerCase() ) {
          findOne = docs;
        }
      });
      return findOne;
    },
    // 当前选型的solidworkes模型的下载进度
    model_down_progress() {
      const { SkuID } = this.lectoParams;
      const findOne = this.progressData[`${SkuID}_model_file`] || {};
      return findOne.progress || 0;
    },
    // 当前选型的普通模型的下载进度
    step_down_progress() {
      // 下载失败恢复 按钮可点
      if(!this.downloadStatus) {
          return 0;
      }
      const { SkuID } = this.lectoParams;
      const findOne = this.progressData[`${SkuID}_step_file`] || {};
      return findOne.progress || 0;
    },
    // 当前选型的普通模型的下载数据
    step_down_obj() {
      const { SkuID } = this.lectoParams;
      const findOne = this.progressData[`${SkuID}_step_file`] || {};
      return findOne || {};
    },
    // solidworks特征模型是否可下载
    isModelDown() {
      return this.lectoParams.IsSelected && this.lectoParams.ModelFileServerPath;
    },
    // 模型是否可下载
    isStepDown() {
      let hasStepMx = false;
      const { IsSeries, IsSelected, StepFileServerPath, ModelFileServerPath } = this.lectoParams;
      if (IsSeries || (this.productDetail.HasModel == 2)) {
        if(StepFileServerPath && IsSelected) {
          hasStepMx = true;
        }
      } else {
        if(ModelFileServerPath || StepFileServerPath && IsSelected) {
          hasStepMx = true;
        }
      }
      return hasStepMx
    },
    hasProview() {
      return CheckLibs.isGreatCraftsman() || CheckLibs.isGreatCraftsmanEnt()
    }
  },
  methods: {
    ...mapMutations('modeldown', ['setProgress']),
    _activeSetupTab() {
      WinForm.md.activeTab('Setup');
    },
    modelFileExtDownCheck() {
      if (!this.isModelDown) return;
      WinForm.tools.downModelCheck((res) => {
        res = JSON.parse(res);
        // res.ProcessNumber = 1;
        // res.Message = 'success';
        // console.log(res);
        if (res.ProcessNumber > 0) {
          if(res.Message == 'success') {
            this.modelDownStart();
          } else {
            let errTitle = '大工程师插件没有正确安装';
            let errText = '<p>1、在设置页面点击安装SolidWorks插件</p><p>2、打开SolidWorks，查看大工程师菜单是否存在</p><p>3、如果不存在，则在SolidWorks的工具菜单中，选择“插件”，勾选上“大工程师”</p><p>4、重新下载模型</p>';
            if (res.ProcessNumber > 1) {
              errTitle = 'SolidWorks未能正常关闭';
              errText = '请在“任务管理器中”结束所有Solidworks的进程，然后打开Solidworks重试！';
            }
            MessageBox.alert(errText, errTitle, {
              confirmButtonText: '去设置页',
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
            }).then(() => {
              WinForm.md.activeTab('Setup')
            })
          }
        } else if(res.ProcessNumber == 0) {
          ElMessage.error(res.Message);
        }
      });
    },
    modelDownStart() {
      this.downLoadCheck(() => {
        this.modelFileExtDown();
      })
    },
    stepDownStart() {
      this.downLoadCheck(() => {
        this.stepFileExtDown();
      })
    },

      // 特征模型预览 
    async stepOnlyProview() {
       const { ProdID } = this.productDetail;
      const { SkuID, StepFileName, StepFileServerPath } = this.lectoParams;
      let standdrdId = ''; // 导入标准件
      // 特征模型 skuid 取值
      let curSkuId =  SkuID;
      if(StepFileServerPath) {
        const arr = StepFileServerPath.split('/');
        const len =  arr.length;
        if(len > 1) {
          curSkuId = arr[`${len - 1}`];
          standdrdId = arr[`${len -2}`];
        }
      }
      

      console.log( this.lectoParams, ' this.lectoParams');
      if (!this.isStepDown) return;
      if (!StepFileServerPath) {
        !this.stepBuilding && this.BuildStepFile();
        this.stepBuilding = true;
        this.stepOnlyProviewTimeout();
        return;
      }
      this.stepBuilding = false;
      this.fullLoading = Loading.service({
        lock: true,
        text: '获取预览数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        const res = await ProdHtService.filePreview({
          prodId: standdrdId || ProdID, 
          fileName: StepFileName||'', 
          dataId:'0', // 默认0 
          skuId: curSkuId,
          categoryId: '265', // 先写死 265，后端数据表的id
        });
        
        this.fullLoading && this.fullLoading.close();
        if (res) {
          this.handleClickPreview();
          this.createIframe(`https://cad-aps.global-dsc.cn/?filePath=${res}`)
        }
      } catch (error) {
        this.fullLoading && this.fullLoading.close();
      }

    },
    // 循环请求,等待模型生成
    stepOnlyProviewTimeout() {
      stepOnlyProviewTimeoutObj && clearInterval(stepOnlyProviewTimeoutObj);
      stepOnlyProviewTimeoutObj = setTimeout(async () => {
        await this.$parent.$parent.filterLectotypeParams();
        this.stepOnlyProview();
      }, 6000)
    },

    // 通用模型预览 
    async docOnlyProview() {
       const { ID, FileName } = this.docDetail;
       const { ProdID } = this.productDetail;
       const { SkuID, SkuName } = this.lectoParams;

      this.fullLoading = Loading.service({
        lock: true,
        text: '获取预览数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        const res = await ProdHtService.filePreview({
          prodId:ProdID, 
          fileName: FileName||'', 
          dataId:ID||'',
          skuId: SkuID,
          categoryId: '265', // 先写死 265，后端数据表的id
        });
        this.fullLoading && this.fullLoading.close();
        if (res) {
          this.handleClickPreview();
          this.createIframe(`https://cad-aps.global-dsc.cn/?filePath=${res}`)
        }
      } catch (error) {
        this.fullLoading && this.fullLoading.close();
      }

    },

    // 模型预览
    async docProview() {
      const { ID, FileName } = this.docDetail;
      this.fullLoading = Loading.service({
        lock: true,
        text: '获取预览数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        const res = await ProdHtService.filedownload(FileName, ID,  this.getHTToken);
        this.fullLoading && this.fullLoading.close();
        if (res) {
          const {documentId,Htoken} = res;
          // window.open(`https://cad-aps.crowncad.com/thirdparty/embed?documentId=${documentId}&access_token=${Htoken}&write=true&redirectDomain=https://cad.crowncad.com`)
          window.open(`https://cad-aps.crowncad.com/thirdparty/document?documentId=${documentId}&access_token=${Htoken}&write=true&redirectDomain=https://cad.crowncad.com`)
        }
      } catch (error) {
        this.fullLoading && this.fullLoading.close();
      }
    },
    async stepProview() {
      const { SkuName, StepFileName, StepFileServerPath } = this.lectoParams;
      if (!this.isStepDown) return;
      if (!StepFileServerPath) {
        !this.stepBuilding && this.BuildStepFile();
        this.stepBuilding = true;
        this.stepProviewTimeout();
        return;
      }
      this.stepBuilding = false;
      this.fullLoading = Loading.service({
        lock: true,
        text: '获取预览数据...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      try {
        const res = await ProdHtService.download(StepFileServerPath.replace('prod','prodHt'), StepFileName, SkuName, this.getHTToken);
        this.fullLoading && this.fullLoading.close();
        if (res) {
          const {documentId,Htoken} = res;
          window.open(`https://cad-aps.crowncad.com/thirdparty/document?documentId=${documentId}&access_token=${Htoken}&write=true&redirectDomain=https://cad.crowncad.com`)
        }
      } catch (error) {
        this.fullLoading && this.fullLoading.close();
      }
    },
    stepProviewTimeout() {
      stepProviewTimeoutObj && clearInterval(stepProviewTimeoutObj);
      stepProviewTimeoutObj = setTimeout(async () => {
        await this.$parent.$parent.filterLectotypeParams();
        this.stepProview();
      }, 6000)
    },




    // 下载SolidWorks特征模型
    modelFileExtDown() {
      const { ModelFileServerPath, StepFileName } = this.lectoParams;
      if (!this.isModelDown) return;
      const url = `${ApiService.JrzzApi}/${ModelFileServerPath}?token=${AuthService.token(false)}`;
      this._down_load_file(url, 'model_file');
    },
    // 下载模型
    stepFileExtDown(isExist = false) {
      if(!isExist) { this.downloadStatus = true; } // 点击按钮，恢复下载状态

      const { ModelFileServerPath, StepFileName, StepFileServerPath } = this.lectoParams;
      if (!this.isStepDown) return;
      const url = `${ApiService.JrzzApi}/${ModelFileServerPath}/1?token=${AuthService.token(false)}&fileName=${encodeURI(StepFileName)}`;
      if (!StepFileServerPath && !isExist) {
        this.BuildStepFile();
      }
    
      this._down_load_file(
        url,
        'step_file',
        isExist,
      );
    },

    // 通知服务端进行模型构建
    BuildStepFile() {
      if (!this.lectoParams.SkuName) return false;
      const SelConfigs = this.lectoParams.LectotypeParams.map(item => ({ ID: item.ID, Value: item.Value }));
      ProductService.SaveStepJson(this.lectoParams.SkuName, this.lectoProId, SelConfigs);
    },

    openDownFile(file_type = '') {
      WinForm.md.openDirectory(`/select,${file_path[file_type]}`);
    },

    // 文件下载
    async _down_load_file( url = '', file_type = '', isExist = false) {
      const { SkuName, SkuID } = this.lectoParams;
      const key = SkuID + '_' + file_type;
      if (this.isLoading && !isExist) {
        ElMessage('正在下载，请稍后');
        return false;
      }

      // const check = await downloadCheckFun(this.productDetail.CompID, this.productDetail.ProdID);
      // if (!check) return;
      let fileName = '';
      if (this.productDetail.CompID == 0) {
        fileName = formatBzjName(this.productDetail.ProdName, this.productDetail.PromoteName, this.lectoParams.SkuName, this.lectoParams);
      } else {
        fileName = UtilService.SpecialCharacter(`${this.productDetail.ProdName}[${this.lectoParams.SkuName}]`);
      }

      const file_ext = file_type === 'model_file' ? this.lectoParams.ModelFileExt : 'step';
      if (!isExist) {
        let savePath = '';
        const modelSaveType = getModelSaveType(this.productDetail.CompID);
        if (modelSaveType.saveType === 1) {
          savePath = await getSavePath(fileName, file_ext);
        } else {
          savePath = modelSaveType.savePath + "\\" + fileName + "." + file_ext;;
        }
        if(!savePath) return;

        this.downOption = download(savePath, file_type, this.lectoParams, this.productDetail, this.IsAddToCurrentAssembly, this.lectoProId);
      }
      console.log(this.downOption);

      console.log(this.downOption.downUrl)

      file_path[file_type] = this.downOption.downloadArgs.SavePath;
      this.isLoading = true;

      //添加到下载任务
      this.setProgress({
          type: 'add',
          key,
          value: {
            sku_name: SkuName,
            file_name: fileName,
            file_type,
            url,
            status: 'download',
            progress: 1,
          },
      });
      WinForm.md.download2(this.downOption.downUrl, this.downOption.downTo, key, this.DownLoadProgress);
     
    },

    DownLoadProgress(key, progress, speed, status, statusDesc, totalSize) {//下载回调
      console.log(key, progress, speed, status, statusDesc, totalSize);

      // 下载失败停止请求
      if(!this.downloadStatus) {
        if(this.downloadTimer) {
          clearTimeout(this.downloadTimer);
          this.downloadTimer = null;
        }
        return;
      }
      switch (status) {
        case "MD_DOWNLOAD"://下载中
          this.setProgress(
            {
              type: progress >= 100 ? 'del' : 'edit_gress',
              key,
              progress: progress <= 0 ? 1 : progress,
              status: 'download'
            }
          );
          break;
        case "MD_COMPLETE"://下载完成
          this.isLoading = false;
          this.setProgress(
            {
              type: 'edit_gress',
              key,
              status: 'complete',
              progress: 100,
            }
          );
          this.completeHandler();
          break;
        default://下载异常  启动失败
          if (this.downOption.downloadComplete === 'openStepModel') {
            this.setProgress(
              {
                type: 'edit_gress',
                key,
                status: 'servicebuild',
                progress: 1,
              }
            );
            if(this.downloadTimer) {
              clearTimeout(this.downloadTimer);
              this.downloadTimer = null;
            }
            this.downloadTimer = setTimeout(() => {
              this.stepFileExtDown(true);
              this.handleDownloadErrorrTip();
            }, 8000)
          } else {
            ElMessage('下载异常');
            this.isLoading = false;
          }
          break;
      }
    },

    completeHandler() {//完成状态，进度100%之后
      switch (this.downOption.downloadComplete) {
        case "driveProdModel":
          DownloadService.driveModelMx(this.downOption.downloadArgs, () => {})
          break;
        case "openStepModel":
          DownloadService.driveModelStep(this.downOption.downloadArgs, () => {});
          break;
      }
    },
      // 模型下载错误提示处理
    async handleDownloadErrorrTip() {
      const userinfo =  UserService.user();
      const params = {
        skuName :this.lectoParams.SkuName,
        prodId: this.productDetail.ProdID,
        userId: userinfo.UserID,
      }
      const res = await ProductService.measureDownloadSuccess(params);
      this.downloadStatus = res.Success;
        // 模型下载失败
      if(!this.downloadStatus) {
        MessageBox.alert(`${res.errMessage}`, '错误提示', {
          confirmButtonText: '确定',
          callback: actions => { 
            this.isLoading = false;
          }
        });
         if(this.downloadTimer) {
          clearTimeout(this.downloadTimer);
          this.downloadTimer = null;
        }
      }
    },

    // 获取华天token 在调用响应的方法
    async getHTToken() {
      // 增加华天鉴权
      let finalToken = '';
        try {
          // 显示弹框并等待返回结果
          finalToken = await this.$refs.getHTTkenRef.show();
        } catch (error) {
          console.log('用户取消或弹框关闭:', error);
          return; // 用户取消，中断流程
        }
      return finalToken
    }
  }
}
</script>

<style lang="less" scoped>
.set-icon{
  position: absolute;
  right: 7px;
  top: 7px;
  width: 26px;
  height: 26px;
  font-size: 20px;
  color: #606266;
  cursor: pointer;
  text-align: center;
  line-height: 25px;
}
.down-box{
  width: 100%;
  height: 42px;
  background: #F1F1F1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  position: relative;
  &>div.disable{
    background: #ccc;
    cursor: not-allowed;
  }

  /deep/ .doc-download{
    width: 100px;
    height: 30px;
    background: #DA9B3D;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 12px;
  }
  /deep/ .progress-wrapper{
    margin: 0;
    width: 100%;
    height: 100%;
    background-color: #ccc;
  }
  /deep/ .drawing-progress .progress-div{
    background: #DA9B3D;
  }
}
.solid-work-btn{
  width: 120px;
  height: 30px;
  background: linear-gradient(90deg, #0989C5 0%, #995CB6 100%);
  border-radius: 4px;
  margin-right: 12px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.down-btn{
  width: 120px;
  height: 30px;
  background: #DA9B3D;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  cursor: pointer;
}
.solid-work-view{
  width: 200px;
  height: 30px;
  margin-right: 12px;
}
.down-view{
  width: 100px;
  height: 30px;
}
.solid-work-view,.down-view{
  background: #ccc;
  cursor: not-allowed;
  position: relative;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  &.open{
    cursor: pointer;
  }
  &>div{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  &>span{
    position: relative;
    z-index: 2;
  }
}
.yulan-button{
  margin-right: 12px;
  height: 30px;
  padding: 0 15px;
  font-size: 15px;
  &.is-disabled{
    background-color: #ccc;
    border: 1px solid #ccc;
  }
}
</style>
